export default __webpack_public_path__ + "static/media/Cosmo_Acrylic_Painting.f842242a.jpg";